import { render, staticRenderFns } from "./PhoenixWelcomeInfo.vue?vue&type=template&id=10f4a66e&scoped=true"
import script from "./PhoenixWelcomeInfo.vue?vue&type=script&lang=js"
export * from "./PhoenixWelcomeInfo.vue?vue&type=script&lang=js"
import style0 from "./PhoenixWelcomeInfo.vue?vue&type=style&index=0&id=10f4a66e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10f4a66e",
  null
  
)

export default component.exports